export enum ActionOverlays {
  None = 'noop',
  Reconnect = 'reconnect',
  PriceBreakdown = 'price-breakdown',
  MakePayment = 'make-payment',
  Disconnect = 'disconnect',
  ChangePackage = 'change-package',
  RentAMovie = 'rent-movie',
  TopUpWallet = 'top-up-wallet',
  RewardsOptIn = 'join-rewards',
  RewardsOptOut = 'cancel-rewards',
  RewardsViewAll = 'rewards-view-all',
  InsuranceClaim = 'insurance-claim',
  InsuranceCancel = 'insurance-cancel',
  InsuranceAdd = 'insurance-add',
  InsuranceManageBeneficiary = 'insurance-manage',
  InsuranceManageFamilyMembers = 'insurance-members',
  XtraViewLink = 'xtraview-link',
  XtraViewUnlink = 'xtraview-unlink',
  LinkPackage = 'link-package',
  SelectLinkPackage = 'select-link-package',
  ExtraStream = 'extra-stream',
  CancelShowmax = 'cancel-showmax',
  SubscriptionWaiverActivate = 'subscription-waiver-activate',
  FuneralCoverAdd = 'funeral-cover-add',
  DebtWaiverOverlay = 'debt-waiver-activate',
  InternetDataBalance = 'internet-data-balance',
  CancelPolicy = 'cancel-policy',
  InternetDeviceNameUpdate = 'internet-device-name-update',
  InternetSetSpendLimit = 'internet-set-spend-limit',
  InternetRechargeData = 'internet-recharge-data',
  InternetUpdateLocation = 'internet-update-location',
  InternetDisconnect = 'internet-disconnect',
  InternetReconnect = 'internet-reconnect',
  InternetChangePackage = 'internet-change-package',
  InternetFibreCancel = 'internet-fibre-cancel',
  InternetRelocateFibre = 'internet-relocate-fibre',
  PaymentResult = 'payment-result',
  PackageSelection = 'package-selection',
  PackageActivation = 'package-activation',
  MonthlyToBundle = 'monthly-to-bundle',
  CarePlanCallMeBack = 'device-care-plan',
  RedeemVoucher = "redeem-capitec-voucher",
  CancelSchedule = 'cancel-schedule'
}
